// Pure client-profitability figures. No Firestore.
//
// Lump-sum billers (CBRE, Nagina, CPBM) have no revenue/reimbursement split in
// their invoices — the whole invoice amount is booked as service charge — so
// their Net Service Revenue is that revenue less the direct cost recorded for
// them. GST is never revenue, so it is left out (the same basis the Monthly P&L
// uses). Every other client has a proper line split: Net Service Revenue is the
// sum of its revenue lines and any direct cost (e.g. an accepted client
// adjustment) is netted off in "Net of Direct Cost" without distorting that revenue.
export const LUMP_SUM_CLIENTS = Object.freeze(["CBRE", "NAGINA", "CPBM"]);

export function profitabilityFigures({ clientCode, rawNetServiceRevenue, directCost }) {
  const raw = Math.round(Number(rawNetServiceRevenue || 0));
  const cost = Math.round(Number(directCost || 0));
  if (LUMP_SUM_CLIENTS.includes(clientCode)) {
    const netServiceRevenue = raw - cost;
    return { netServiceRevenue, netOfDirectCost: netServiceRevenue };
  }
  return { netServiceRevenue: raw, netOfDirectCost: raw - cost };
}
